const STORAGE_KEY = "its_quiz_state";

interface StoredState {
  submissionId: string;
  testSlug: string;
  savedAt: number;
}

export function useQuiz(testSlug: string) {
  const getSaved = (): StoredState | null => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const s = JSON.parse(raw) as StoredState;
      if (s.testSlug !== testSlug) return null;
      if (Date.now() - s.savedAt > 24 * 60 * 60 * 1000) return null;
      return s;
    } catch {
      return null;
    }
  };

  const save = (submissionId: string) =>
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ submissionId, testSlug, savedAt: Date.now() }),
    );

  const clear = () => sessionStorage.removeItem(STORAGE_KEY);

  return { getSaved, save, clear };
}
